export const REPORT_REASON_LABEL_KEYS = [
  "common.reportReasonIrrelevant",
  "common.reportReasonOffensive",
  "common.reportReasonSpam",
  "common.reportReasonFakeNews",
  "common.reportReasonScam",
  "common.reportReasonProhibited",
  "common.reportReasonViolent",
  "common.reportReasonUnknownCharacters",
  "common.reportReasonOtherConcerns",
] as const;

export type ReportReasonLabelKey = (typeof REPORT_REASON_LABEL_KEYS)[number];

export interface ReportReason {
  id: number;
  labelKey: ReportReasonLabelKey;
}

export const REPORT_REASONS: readonly ReportReason[] = [
  { id: 1, labelKey: "common.reportReasonIrrelevant" },
  { id: 2, labelKey: "common.reportReasonOffensive" },
  { id: 3, labelKey: "common.reportReasonSpam" },
  { id: 4, labelKey: "common.reportReasonFakeNews" },
  { id: 5, labelKey: "common.reportReasonScam" },
  { id: 6, labelKey: "common.reportReasonProhibited" },
  { id: 7, labelKey: "common.reportReasonViolent" },
  { id: 8, labelKey: "common.reportReasonUnknownCharacters" },
  { id: 9, labelKey: "common.reportReasonOtherConcerns" },
] as const;

export const getReportReasonFallback = (reasonId: number) =>
  `Reason ${reasonId}`;
